const pLinkCardArr = $(".p-link-card");
for (let i = 0; i < pLinkCardArr.length; i++){
	const target = pLinkCardArr[i];
	const url = $(target).children("a").attr("href");
	const nameText = $(target).children("a").text();
	let newObj = {};
	fetch(url).then(res => res.text()).then(text => {
		const element = new DOMParser().parseFromString(text, "text/html");
		const headEls = (element.head.children);
		let obj = {};
		Array.from(headEls).map(v => {
			const prop = v.getAttribute('property')
			if (!prop) return;
			obj[prop] = v.getAttribute("content");
		})
		const ogurl = obj['og:url'];
		const ogprice = "&yen;" + obj['og:price:amount'] + "-";
		const ogtitle = obj['og:title'].replace(" | PREDUCTS", "").replace("モジュール式電動昇降デスク ", "").replace("電動昇降デスク用天板 ", "");
		const ogimg = obj['og:image'] || "http://preducts.jp/cdn/shop/files/og-image_1200x1200.jpg";
		//const ogdescription = obj['og:description'];
		if (ogurl.match('404')){
			target.innerHTML = "<figure><img src='" + ogimg + "'></figure><div class='p-link-card-contents'><h4 class='p-name'>" + nameText + "</h4><p class='p-price'>" + "販売終了" + "</p></div>";
		} else {
			target.innerHTML = "<a href='" + ogurl + "'><figure><img src='" + ogimg + "'></figure><div class='p-link-card-contents'><h4 class='p-name'>" + ogtitle + "</h4><p class='p-price'>" + ogprice + "</p></div>";
		}
	})
}